<template>
	<v-container>
		<v-content>
			<v-container>
				<v-layout class="mb-5" row wrap>
					<v-flex v-if="loaded" xs12>
						<div class="mb-1 display-3 text-xs-center" v-if="valid">{{$t('labels.passwordResetOk')}}</div>
						<div class="mb-1 display-3 text-xs-center" v-if="!valid">{{$t('labels.passwordResetFail')}}
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-container>
</template>

<script>
	export default {
		name: "PasswordReset",
		components: {},
		props: {
			token: String,
		},
		data: function () {
			return {
				valid: true,
				loaded: false
			}
		},
		methods: {},
		mounted() {
			let data = {
				token: this.$route.params.token
			};
			let vm = this;
			this.$APICall('post', 'password-reset', data, (data, success) => {
				vm.valid = success;
				vm.$nextTick(() => {
					vm.loaded = true;
				});
			});
		}
	}
</script>

<style scoped>

</style>
